
import { useState } from "react"
import { Paper, TableContainer, Table, TableHead, TableRow, TableCell, TablePagination, TableBody, Grid, Typography } from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles'
import { formatDinero } from "./../../../../utils/formatDinero"
import { FormatoFechaIso } from "./../../../../utils/FormatFecha"
import ButtonClienteDetalle from "../../../../global/ButtonClienteDetalle"
import Brightness1Icon from '@material-ui/icons/Brightness1';
const columns = [
    { id: "referencia", minWidth: 50, align: "center", label: "Referencia" },
    { id: "Deposito", minWidth: 50, align: "center", label: "Deposito" },
    // { id: "tipoCambio", minWidth: 50, align: "center", label: "T.C.C." },
    { id: "compra", minWidth: 50, align: "center", label: "Compra USD" },
    { id: "tipoCambio", minWidth: 50, align: "center", label: "T.C." },
    { id: "venta", minWidth: 50, align: "center", label: "Venta USD" },
    { id: "utiliad", minWidth: 50, align: "center", label: "Utilidad USD" },
    { id: "fechaPago", minWidth: 50, align: "center", label: "Fecha Pago" },
    { id: "isPeso", minWidth: 50, align: "center", label: "" },
]

const useStyles = makeStyles({
    containerRoot: {
        marginTop: "25px",
        marginBottom: "25px"
    },
    containerRootButton: {
        marginTop: "25px",
        marginBottom: "25px",
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center"
    },
    root: {
        width: '100%',
        padding: '0'
    },
    container: {
        maxHeight: 440,
    },
})

const TMovimientos = ({ rows = [] }) => {
    const classes = useStyles()
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(10)

    const handleChangePage = (event, newPage) => {
        setPage(newPage)
    }

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value)
        setPage(0)
    }

    return (
        <div className={classes.containerRoot}>
            <Grid container>
                <Grid item xs={4}>
                    <Typography variant="subtitle1" style={{ fontWeight: 700, margin: "0.4rem" }}>
                        T.C.C.: {formatDinero(rows[0]?.tipoCambioCorteCaja)}
                    </Typography>
                </Grid>
            </Grid>
            <Paper className={classes.root}>
                <TableContainer className={classes.container}>
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow>
                                {columns.map((column) => (
                                    <TableCell
                                        key={column.id}
                                        align={column.align}
                                        style={{ minWidth: column.minWidth }}
                                    >
                                        {column.label}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {
                                return (
                                    <TableRow hover role="checkbox" tabIndex={-1} key={row.id_movCuenta}>
                                        <TableCell align='center'>
                                            <ButtonClienteDetalle referencia={row.Referencia} />
                                        </TableCell>
                                        <TableCell align='center'>
                                            {`${formatDinero(row.monto)}`}
                                        </TableCell>
                                        {/* <TableCell align="center">
                                            {`${formatDinero(row.tipoCambioCorteCaja)}`}
                                        </TableCell> */}
                                        <TableCell align="center">
                                            {`${formatDinero(row.montoUSDCorteCaja)}`}
                                        </TableCell>
                                        <TableCell align="center">
                                            {`${formatDinero(row.tipoCambio)}`}
                                        </TableCell>
                                        <TableCell align="center">
                                            {`${formatDinero(row.montoUSD)}`}
                                        </TableCell>
                                        <TableCell align="center">
                                            {`${formatDinero(row.ganacia)}`}
                                        </TableCell>
                                        <TableCell align="center">
                                            {`${FormatoFechaIso({ date: row.Fecha, formato: "dd-MM-yyyy" })}`}
                                        </TableCell>
                                        <TableCell align="center">
                                            <Brightness1Icon color={(row.esPeso) ? "primary" : "secondary"} />
                                        </TableCell>
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[10, 25, 100]}
                    component="div"
                    count={rows.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>
            <Grid item xs={4}>
                    <Typography variant="subtitle1" style={{ fontWeight: 700, margin: "0.4rem", display: "flex", justifyContent: "flex-start", alignItems:"center" }}>
                        Paquete dolar: <Brightness1Icon color={"secondary"} />
                    </Typography>
                    <Typography variant="subtitle1" style={{ fontWeight: 700, margin: "0.4rem",display: "flex", justifyContent: "flex-start", alignItems:"center" }}>
                        Paquete peso a dolar:<Brightness1Icon color={"primary"} />
                    </Typography>
                </Grid>
        </div>
    )
}
export default TMovimientos